import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Layout } from 'antd';
import { PoweroffOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import moment from 'moment-jalaali';
import logo from '../../../../assets/img/logo/logo.png';

const { Header } = Layout;

const TopbarName = styled.div`
  margin: 0 20px;
  display: inline;
  font-size: 20px;
  border-left: 1px solid #fff;
  padding-left: 20px;
`;

const LogoContainer = styled.div`
  display: inline;
  margin-top: 15px;
  position: relative;
`;

const Logout = styled.div`
  display: inline;
  float: left;
  margin-left: 15px;
`;

const CurrentDate = styled.div`
  display: inline;
  & > span {
    margin-left: 10px;
  }
`;

const Topbar = () => {
  const navigate = useNavigate();

  return (
    <Header className='header' style={{ background: 'rgba(97, 65, 173, 1)', padding: '0 7px', color: '#fff' }}>
      <div className='logo'>
        {/* <LogoContainer>
          <RouterLink to='/'>
            <img alt='Logo' style={{ height: 30, borderRadius: '50%', position: 'fixed', top: 17 }} src={logo} />
          </RouterLink>
        </LogoContainer> */}
        <TopbarName>
          <span>ادمین وبسایت شادزی شو</span>
        </TopbarName>
        <CurrentDate>
          <span> {moment(new Date().toJSON().slice(0, 10).replace(/-/g, '/'), 'YYYY-MM-DD').format('dddd')}</span>
          <span>
            {moment(new Date().toJSON().slice(0, 10).replace(/-/g, '/'), 'YYYY-MM-DD').format('jYYYY/jMM/jDD')}
          </span>
        </CurrentDate>
        <Logout>
          <button
            type='button'
            onClick={() => {
              navigate('/logout');
            }}
            style={{
              padding: '10px',
              borderRadius: '5px',
              backgroundColor: 'rgba(255, 255, 255, 0.23)',
              border: '1px solid rgba(255, 255, 255, 0.23)',
              color: '#fff',
              cursor: 'pointer',
              fontFamily: 'IRANSans',
            }}
          >
            خروج
            <PoweroffOutlined style={{ marginRight: '10px' }} />
          </button>
        </Logout>
      </div>
    </Header>
  );
};

export default Topbar;
